module.exports = __webpack_public_path__ + "static/media/05_2.7135dec0.png";